import React from 'react'
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
} from '@mui/material'
import {
  TrendingUp,
  TrendingDown,
  TrendingFlat,
} from '@mui/icons-material'

interface MetricsCardProps {
  title: string
  value: string | number
  subtitle?: string
  trend?: 'up' | 'down' | 'flat'
  trendValue?: string
  color?: 'primary' | 'secondary' | 'success' | 'warning' | 'error' | 'info'
  icon?: React.ReactNode
}

export default function MetricsCard({
  title,
  value,
  subtitle,
  trend,
  trendValue,
  color = 'primary',
  icon,
}: MetricsCardProps) {
  const getTrendIcon = () => {
    switch (trend) {
      case 'up':
        return <TrendingUp fontSize="small" />
      case 'down':
        return <TrendingDown fontSize="small" />
      case 'flat':
        return <TrendingFlat fontSize="small" />
      default:
        return null
    }
  }

  const getTrendColor = () => {
    switch (trend) {
      case 'up':
        return 'success'
      case 'down':
        return 'error'
      case 'flat':
        return 'default'
      default:
        return 'default'
    }
  }

  return (
    <Card sx={{ height: '100%', position: 'relative' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          {icon && (
            <Box sx={{ mr: 1, color: `${color}.main` }}>
              {icon}
            </Box>
          )}
          <Typography color="textSecondary" gutterBottom variant="body2">
            {title}
          </Typography>
        </Box>
        
        <Typography variant="h4" component="div" sx={{ mb: 1, fontWeight: 'bold' }}>
          {typeof value === 'number' ? value.toLocaleString() : value}
        </Typography>
        
        {subtitle && (
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            {subtitle}
          </Typography>
        )}
        
        {trend && trendValue && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Chip
              icon={getTrendIcon() ?? undefined}
              label={trendValue}
              size="small"
              color={getTrendColor()}
              variant="outlined"
            />
          </Box>
        )}
      </CardContent>
    </Card>
  )
}